import { ViewerContext } from 'dash-ui';
import {
  createGTMEvent,
  getGoogleTagManagerUserId,
} from 'common/google-tag-manager/helpers';
import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export const useLocationChangeListener = () => {
  const location = useLocation();
  const { account, subscription } = useContext(ViewerContext);

  useEffect(() => {
    if (!account) return;
    createGTMEvent({
      dataLayer: {
        user_id: getGoogleTagManagerUserId(account.email),
        signup_date: `${account.createdAt}`.split('T')[0],
        subscription_status: subscription?.status,
        subscription_plan: subscription?.subscriptionProduct?.recurringType,
        subscription_type: subscription?.subscriptionProduct?.name,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, account]);
};
